/**
 * Public publisher capability summary (R18 — landing claims derived from live
 * data). publishing-service `GET /api/v1/publishing/public/capabilities-summary`
 * — no auth (gateway GET-only public prefix). Static registry data only.
 */
import { api } from '@/lib/api/client';

export interface PublicNetwork {
  id: string;
  label: string;
}

export interface PublicCapabilitiesSummary {
  network_count: number;
  networks: PublicNetwork[];
  source: string;
}

export function getPublicCapabilitiesSummary(): Promise<PublicCapabilitiesSummary> {
  return api.get<PublicCapabilitiesSummary>('/api/v1/publishing/public/capabilities-summary');
}
